// 9fbef606107a605d69c0edbcd8029e5d
import LOYALTY_PLACE_REWARDS_CONSTANTS from '../LoyaltyPlaceRewards.constants';

export const getTierBenefits = (payload) => ({
  type: LOYALTY_PLACE_REWARDS_CONSTANTS?.GET_TIER_BENEFITS,
  payload,
});

export const setLoyaltyTierBenefits = (payload) => ({
  type: LOYALTY_PLACE_REWARDS_CONSTANTS?.SET_LOYALTY_TIER_BENEFITS,
  payload,
});

export const fetchLoyaltyBenefitJsonRequest = () => ({
  type: LOYALTY_PLACE_REWARDS_CONSTANTS.FETCH_LOYALTY_BENEFIT_JSON_REQUEST,
});

export const fetchLoyaltyBenefitJsonSuccess = (payload) => ({
  type: LOYALTY_PLACE_REWARDS_CONSTANTS.FETCH_LOYALTY_BENEFIT_JSON_SUCCESS,
  payload,
});

export const fetchLoyaltyBenefitJsonFailure = (payload) => ({
  type: LOYALTY_PLACE_REWARDS_CONSTANTS.FETCH_LOYALTY_BENEFIT_JSON_FAILURE,
  payload,
});

export default setLoyaltyTierBenefits;
